import type { HgClubTableStructures } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import produce from 'immer';

import { getInitialValues } from '../../components/CreateGame/utils/common';
import type { PageData } from '../../types/common';

export const setTableStructures = (
  state: PageData,
  { response: { tableParams } }: { response: HgClubTableStructures }
) =>
  produce(state, (draft) => {
    draft.tableStructures = {
      initialValues: getInitialValues(tableParams),
      tableParams: tableParams ?? []
    };
  });
